import { makeStyles } from '@material-ui/core';
import React from 'react';

const useEstilos = makeStyles(() => ({
    softwareList: {
        listStyle: 'none',
        padding: '0',
        margin: '0',
    }
}));

interface SoftwareListProps {
    items: any[];
}

export const SoftwareList = (props: SoftwareListProps): JSX.Element => {

    const clases = useEstilos(props);
    const { items } = props;

    return (
        <ul className={clases.softwareList}>
            {/* Control if length is 0 */}
            {items}
        </ul>
    )

}